import { DamAssets } from './DamAssets';
import { route } from 'ziggy-js';

export class DamSearch {
    constructor() {
        this.query = '';
        this.showClearBtn = false;
        this.page = 1;
        this.draw = 1;
    }

    init() {
        if (document.querySelector('*[data-role=damAssetSearch]').value !== '') {
            this.query = document.querySelector('*[data-role=damAssetSearch]').value;

            if (this.query !== '') {
                this.showClearBtn = true;
                this.toggleClearBtn();
            }

            this.search();
        }

        this.actions();
    }

    actions() {
        document.querySelector('*[data-role=damAssetSearch]').onkeyup = e => {
            this.query = e.target.value;

            if (this.query !== '') {
                this.showClearBtn = true;
            } else {
                this.showClearBtn = false;
            }

            this.toggleClearBtn();

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.search();
            }, 300);
        }

        document.querySelector('.dam-search-box .dam-clear-search').onclick = e => {
            this.showClearBtn = false;

            this.toggleClearBtn();

            document.querySelector('*[data-role=damAssetSearch]').value = '';
            this.query = '';
            this.search();
        }
    }

    search() {
        this.draw++;

        document.querySelectorAll('input.dam-tag-checkbox').forEach(el => el.checked = false);

        const pageTitle = document.querySelector('h1').innerText;
        const currentOrder = new URL(window.location.href).searchParams.get('order');

        window.history.pushState(pageTitle, pageTitle, `${route('dam.index')}?draw=${this.draw}&page=${this.page}&searchQuery=${this.query}&order=${currentOrder}`);

        const damAssets = new DamAssets();

        damAssets.assets();
    }

    async toggleClearBtn() {
        if (this.showClearBtn) {
            document.querySelector('.dam-search-box .dam-clear-search').classList.remove('d-none');
        } else {
            document.querySelector('.dam-search-box .dam-clear-search').classList.add('d-none');
        }
    }
}
